






import {
  defineComponent,
  onErrorCaptured,
  useContext
} from '@nuxtjs/composition-api';

import { useUiNotification } from '~/composables';
import { Logger } from '~/helpers/logger';

export default defineComponent({
  name: 'ErrorBoundary',
  emits: ['error'],
  setup(_, { emit }) {
    const { send: sendNotification } = useUiNotification();
    const { app } = useContext();

    onErrorCaptured((error: Error) => {
      emit('error', error);
      sendNotification({
        icon: 'error',
        id: Symbol(),
        message: app.i18n.t('common.error.message') as string,
        persist: false,
        title: 'Unexpected error',
        type: 'danger'
      });

      Logger.error('[ErrorBoundary]:', error);

      // Prevent error propagation
      return false;
    });
  }
});
